'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pkg = require('pkg/good-listener/listen');
exports.default = pkg;